import http from "./HttpService";

import { API_BASE_PUBLISH } from "../../constants/index";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";

export function getPublishService(version_id: number, outlookRoute?: number) {
  let url = `${API_BASE_PUBLISH}publish_email/?version_id=${version_id}`;
  if (outlookRoute) url = `${url}&outlook_route=${outlookRoute}`;
  return http.get(url, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function getPublishEmailSendService(data: FormData) {
  return http.post(API_BASE_PUBLISH + "publish_email/", data, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  }); //change to post send email call
}

export function getPublishAIEmailSendService(data: FormData) {
  return http.post(API_BASE_PUBLISH + "publish_ai_email/", data, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  }); //change to post send email call
}

export const scheduleEmailService = (data: FormData) => {
  return http.post(`${API_BASE_PUBLISH}schedule_email/`, data);
};

export function sendEmailWithOutlookService(
  campaignId: string,
  emailId: string,
  outlookRoute: string,
  is_custom: string
) {
  let payload = new FormData();
  payload.append("campaign_id", campaignId);
  payload.append("email_id", emailId);
  payload.append("outlook_route", outlookRoute);
  payload.append("is_custom", is_custom);

  return http.post(API_BASE_PUBLISH + "outlook_authorized/", payload, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function emailWithOutlookCallbackService(code: string, state: string, sessionState: string) {
  return http.get(API_BASE_PUBLISH + `callback/?code=${code}&state=${state}&session_state=${sessionState}`, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export const saveEmailDataService = (data: FormData) => {
  return http.post(API_BASE_PUBLISH + "publish_configurations/", data);
};

export const getRecipientCountService = (data: FormData) => {
  return http.post(API_BASE_PUBLISH + "recipients_count/", data);
};

export const getHTMLLinkService = (data: FormData) => {
  return http.post(API_BASE_PUBLISH + "email_html/", data);
};

export function getPromoCodesService(campaignId: string) {
  return http.get(API_BASE_PUBLISH + `export_widget/?campaign_id=${campaignId}`);
}

export function getOldPromoCodesService(campaignId: string) {
  return http.get(API_BASE_PUBLISH + `old_export_widget/?campaign_id=${campaignId}`);
}

export const oldExportWidgetsService = (promotionCodes: string[]) => {
  const payload = new FormData();
  payload.append("promotion_codes", JSON.stringify(promotionCodes));
  payload.append("campaign_id", getQueryCampaignId().toString());
  return http.post(API_BASE_PUBLISH + "old_export_widget/", payload);
};
